import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { PasswordResetActions } from 'Redux/modules/passwordReset/actions';
import { PasswordResetSelectors } from 'Redux/modules/passwordReset/selectors';
import AppConfig from 'Config/AppConfig';
import { errorMessage } from './errorMessages';
import ResetSent from './ResetSent';
import AuthFooter from '../../../Components/AuthFooter/AuthFooter';
import PiplLogo from '../../../../../static/img/pipl_logo.svg';
import styles from './PasswordReset.module.less';

const CONTACT_EMAIL = 'support@pipl.com';

// Ported from accounts/templates/pages/password_reset/password_reset.html
// When sent === true, renders the ResetSent confirmation inline.
export function RequestReset() {
  const dispatch = useDispatch();
  const isSubmitting = useSelector(PasswordResetSelectors.passwordResetIsSubmittingSelector);
  const sent = useSelector(PasswordResetSelectors.passwordResetSentSelector);
  const error = useSelector(PasswordResetSelectors.passwordResetErrorSelector);

  const [email, setEmail] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);

  if (sent) {
    return <ResetSent email={email} />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    // Fall back to the live input value so password-manager autofill (which can
    // skip React's onChange) is still picked up.
    const emailValue = email || e.target.elements.email?.value || '';
    dispatch(PasswordResetActions.requestReset({ email: emailValue, captcha: captchaToken }));
  };

  return (
    <>
      <div className={styles['center-form']}>
        <a href="https://pipl.com">
          <img className={`center-block ${styles.logo}`} src={PiplLogo} width="120" height="75" alt="Pipl" />
        </a>

        <div className={styles['form-header']}>
          <h1 className={styles['h-title']}>Password Forget</h1>
        </div>

        <p>
          Forgot your password?
          <br />
          Please enter your email address below, and we&apos;ll send you an email to start the process.
        </p>

        <form id="signup_form" onSubmit={handleSubmit} autoCapitalize="off" autoCorrect="off">
          <div className={styles['form-group']}>
            <input
              className={styles['form-control']}
              id="id_email"
              name="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
            <div className={styles.captcha}>
              <ReCAPTCHA
                sitekey={AppConfig.RECAPTCHA_KEY || (window.__CONFIG__ && window.__CONFIG__.RECAPTCHA_KEY) || ''}
                onChange={(token) => setCaptchaToken(token)}
              />
            </div>
          </div>

          {error && <div className={`${styles['form-group']} ${styles['text-danger']}`}>{errorMessage(error)}</div>}

          <button type="submit" className={styles.btn} disabled={isSubmitting}>
            RESET PASSWORD
          </button>
        </form>

        <br />

        <p>
          If you have any trouble resetting your password, contact us at{' '}
          <a className={styles['contact-link']} href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </div>
      <AuthFooter />
    </>
  );
}

export default RequestReset;
